import {cascadeSum} from "@Common/utils/cascade";

export const sumCreditItems = (items, {itemAttr}) => {
    let ids = [];
    return cascadeSum(items, `[*].billingAvailable.${itemAttr}[*].amountAvailable`, (v, {}, {3:creditItem}) => {
        if (!~ids.indexOf(creditItem.id)) {
            ids.push(creditItem.id);
            return +v;
        } else {
            return 0;
        }
    });
};
